import {OrderDataType} from "./orderDataType";
/**
 * Created by alex.y on 10/3/2017.
 */
export class OrderContentData {
    public Type: OrderDataType;
    public Data: string;
    public Status: number; /*TODO implement this after documents implementation*/

    public constructor(obj?: Partial<OrderContentData>){
        Object.assign(this, obj);
    }
}


// WEBPACK FOOTER //
// ./app/objects/orders/orderContentData.ts